import Loader from "components/shared/loader";
import { audioExtensions, imageExtensions, videoExtensions } from "helpers/system";
import React, { lazy, Suspense, useState } from "react";
import Lightbox from "react-18-image-lightbox";
import FloatingVideo from "../floatingVideo";
import AudioPlayer from "./audio";

const PdfPreview = lazy(() => import("./pdfPreview.js"));

export const renderDownloadLink = (url, name) => {
    return (
        <small>
            <a href={url} download={name} className="link link--download" target="_blank" rel="noopener noreferrer">
                <i className="icon-uEA52-load-point icon-inline pr-1" />
                Скачать
            </a>
        </small>
    );
};

const FileBody = (props) => {
    const name = props.file.originalFileName;
    const url = props.file.accessUrlLink.replace(name, "");
    const accessUrlLink = props.file.accessUrlLink;
    const showPdf = () => {
        props.modal({
            name: "default",
            mod: "full",
            withoutHeader: true,
            CustomBody: (props) => (
                <Suspense fallback={<Loader />}>
                    <PdfPreview {...props} />
                </Suspense>
            ),
            bodyData: { accessUrlLink },
        });
    };
    if (imageExtensions.includes(props.file.extension)) {
        return <ImageBody name={name} url={url} accessUrlLink={accessUrlLink} />;
    } else if (videoExtensions.includes(props.file.extension)) {
        return <VideoBody name={name} url={url} accessUrlLink={accessUrlLink} />;
    } else if (audioExtensions.includes(props.file.extension)) {
        return <AudioBody currentAudio={props.currentAudio} accessUrlLink={accessUrlLink} />;
    }
    return (
        <div className="chat-msg__body chat-msg__body--file">
            <div className="chat-msg__body-icon" />
            <div className="chat-msg__body-text ellipsis" title={name}>
                {name}
            </div>
            {props.file.extension === "pdf" && (
                <small className="link mr-4" onClick={showPdf}>
                    <i className="icon-uEA49-eye icon-inline pr-1" />
                    Просмотреть
                </small>
            )}
            {renderDownloadLink(url, name)}
        </div>
    );
};

export const MultipleFileBody = ({ files = [], ...props }) =>
    files.map((file) => (
        <FileBody key={file.id || file.accessUrlLink || file.originalFileName} {...props} file={file} />
    ));

export const ImageBody = ({ name, url, accessUrlLink }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div className="text-center">
                <img
                    src={accessUrlLink}
                    onClick={() => setIsOpen(true)}
                    className="chat-msg__body-image"
                    title={name}
                    alt={name}
                />
            </div>
            {isOpen && <Lightbox mainSrc={accessUrlLink} onCloseRequest={() => setIsOpen(false)} />}
            <div className="chat-msg__body-image--link">{renderDownloadLink(url, name)}</div>
        </>
    );
};

export const VideoBody = ({ name, url, accessUrlLink }) => {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <>
            <div className="chat-msg__body-video" onClick={() => setIsOpen(true)}></div>
            {isOpen && <FloatingVideo opened src={accessUrlLink} onCloseRequest={() => setIsOpen(false)} portalTarget={document.querySelector(".page-content")} />}
            <div className="chat-msg__body-image--link">{renderDownloadLink(url, name)}</div>
        </>
    );
};

const AudioBody = ({ currentAudio, accessUrlLink }) => {
    return <AudioPlayer currentAudio={currentAudio} accessUrlLink={accessUrlLink} />;
};

export default FileBody;
